const SCHEDULE_VIEW_MODES = {
    week: 'W',
    month: 'M',
    year: 'Y'
};

export default SCHEDULE_VIEW_MODES;
